export default __webpack_public_path__ + "images/soon_presentation.jpg";